import React from 'react';
import { Form, Checkbox, Button, Typography } from 'antd';

const { Title } = Typography;

const samplePDF =
  "https://firebasestorage.googleapis.com/v0/b/operataxis.firebasestorage.app/o/DriverRegistration%2FNetwork%20By%20laws.pdf?alt=media&token=22b71aa9-c881-4c5a-b07d-ca24d780952d";

const Step9 = ({ form, next, prev }) => {
  const handleSubmit = () => {
    form
      .validateFields()
      .then(() => {
        next();
      })
      .catch(errorInfo => {
        console.log('Validation Failed:', errorInfo);
      });
  };

  return (
    <Form form={form} layout="vertical" style={{ maxWidth: 800, margin: '0 auto' }}>
      <Title level={2}>Code of Conduct</Title>

      <div style={{ height: "500px", border: "1px solid #ccc", marginBottom: "20px" }}>
        <iframe
          src={`https://docs.google.com/gview?embedded=true&url=${encodeURIComponent(samplePDF)}`}
          width="100%"
          height="100%"
          style={{ border: "none" }}
          title="PDF Viewer"
        />
      </div>

      <Form.Item
  name="codeOfConduct"
  rules={[{ required: true, message: 'Please confirm you have read the code of conduct.' }]}
>
  <Checkbox
    onChange={(e) => {
      form.setFieldsValue({
        codeOfConduct: e.target.checked ? "agree" : undefined,
      });
    }}
  >
    I have read the code of conduct.
  </Checkbox>
</Form.Item>

      <Form.Item style={{ textAlign: 'center' }}>
        <Button onClick={prev} style={{ marginRight: 8 }}>
          Back
        </Button>
        <Button type="primary" onClick={handleSubmit}>
          Next
        </Button>
      </Form.Item>
    </Form>
  );
};

export default Step9;
